
// Get Orientation
export function IsLandscape()
{
  return window.innerHeight < window.innerWidth;
}

export function IsPortrait()
{
  return !IsLandscape();
}
